/**
 * Render Utilities
 * 
 * Functions for rendering icons, reactions, and other UI elements
 */

import facebookIcon from "@/assets/images/domains/shared/icons/misc/08.png";
import twitterIcon from "@/assets/images/domains/shared/icons/misc/09.png";
import instagram from "@/assets/images/domains/shared/icons/misc/10.png";
import youtube from "@/assets/images/domains/shared/icons/misc/12.png";
import linkedIn from "@/assets/images/domains/shared/icons/misc/13.png";
import pinterest from "@/assets/images/domains/shared/icons/social/pinterest.png";
import tiktokIcon from "@/assets/images/domains/shared/icons/social/tik-tok.png";
import snapchatIcon from "@/assets/images/domains/shared/icons/social/snapchat.png";
import githubIcon from "@/assets/images/domains/shared/icons/social/github.png";
import genericIcon from "@/assets/images/domains/shared/icons/misc/network.png";
import genericDeco from "@/assets/images/domains/profile/banners/empty.png";
import ramadanDeco from "@/assets/images/domains/profile/banners/ramadan.png";
import i18n from "@/i18n";

/**
 * Render reaction emoji
 * @param {string} reaction - Reaction type
 * @returns {string} Emoji for the reaction
 */
export function renderReaction(reaction) {
  switch (reaction) {
    case "LIKE":
      return "👍";
    case "LOVE":
      return "❤️";
    case "SAD":
      return "😢";
    case "ANGRY":
      return "😡";
    case "LAUGH":
      return "😂";
    case "WOW":
      return "😮";
    default:
      return "";
  }
}

/**
 * Render social media icon
 * @param {string} socialMediaName - Social media platform name
 * @returns {string} Icon path
 */
export function renderSocialMediaIcons(socialMediaName) {
  switch (socialMediaName?.toUpperCase()) {
    case "FACEBOOK":
      return facebookIcon;
    case "TWITTER":
      return twitterIcon;
    case "INSTAGRAM":
      return instagram;
    case "YOUTUBE":
      return youtube;
    case "LINKEDIN":
      return linkedIn;
    case "PINTEREST":
      return pinterest;
    case "TIKTOK":
      return tiktokIcon;
    case "SNAPCHAT":
      return snapchatIcon;
    case "GITHUB":
      return githubIcon;
    case "OTHER":
      return genericIcon;
    default:
      return genericIcon;
  }
}

/**
 * Render banner decoration
 * @param {string} bannerDeco - Banner decoration type
 * @returns {string} Decoration image path
 */
export function renderBannerDeco(bannerDeco) {
  // Only RAMADAN has a special decoration, all others use generic
  return bannerDeco === "RAMADAN" ? ramadanDeco : genericDeco;
}

/**
 * Format activity or emotion text with translation
 * @param {Object} item - Activity or emotion item
 * @param {string} type - Type: 'activity' or 'emotion'
 * @returns {string} Formatted text with emoji
 */
export function formatActivityEmotionText(item, type) {
  if (!item) return '';

  const { t, te } = i18n.global;

  if (type === 'emotion') {
    const emotionName = item.name;
    const emotionKey = `emotion.${emotionName}`;
    return te(emotionKey) ? `${t(emotionKey)} ${item.emoji}` : `${emotionName} ${item.emoji}`;
  } else if (type === 'activity') {
    const activityName = item.name;
    const activityKey = `activity.${activityName}`;
    return te(activityKey) ? `${t(activityKey)} ${item.emoji}` : `${activityName} ${item.emoji}`;
  }
  return '';
}

